import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Gift, Copy, Check, Users } from "lucide-react";

export default function ReferralCard() {
  const [info, setInfo] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/referral").then(({ data }) => setInfo(data)).catch(() => {});
  }, []);

  if (!info) return null;
  const link = `${window.location.origin}/inscription?ref=${info.code}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = link; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    setCopied(true);
    toast.success("Lien de parrainage copié !");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="glass rounded-2xl p-6 mb-10 card-hover" data-testid="referral-card">
      <div className="flex flex-wrap items-start justify-between gap-6">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 text-emerald-300">
            <Gift size={16} />
            <span className="text-xs font-mono uppercase tracking-widest">Parrainage</span>
          </div>
          <h3 className="mt-3 text-lg font-semibold">Invitez un ami, gagnez 1 génération bonus</h3>
          <p className="text-sm text-gray-400 mt-1">À chaque inscription via votre lien, une génération supplémentaire est ajoutée à votre compte.</p>
          <div className="mt-4 flex items-stretch gap-2 max-w-xl">
            <input readOnly value={link} className="flex-1 min-w-0 rounded-xl bg-white/5 border border-white/10 px-4 py-2.5 text-xs font-mono text-gray-300 outline-none" data-testid="referral-link-input" />
            <button onClick={copy} className="pill-primary text-sm flex items-center gap-2 shrink-0" data-testid="referral-copy-button">
              {copied ? <Check size={14} /> : <Copy size={14} />} {copied ? "Copié" : "Copier"}
            </button>
          </div>
        </div>
        <div className="flex gap-6">
          <div className="text-center">
            <div className="text-xs font-mono uppercase tracking-widest text-gray-400 flex items-center gap-1 justify-center"><Users size={12} /> Filleuls</div>
            <div className="text-3xl font-bold mt-2" data-testid="referral-count">{info.count}</div>
          </div>
          <div className="text-center">
            <div className="text-xs font-mono uppercase tracking-widest text-gray-400">Bonus dispo</div>
            <div className="text-3xl font-bold mt-2 text-emerald-300" data-testid="referral-bonus">+{info.bonus_credits}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
